import { CLOSE_POPIN, OPEN_POPIN } from '@app/store/actions';
import { EventCreatorMap } from '../../models/helpers';

import popinClose from './popin-close';
import popinOpen from './popin-open';

const eventsMap: EventCreatorMap = {
  [CLOSE_POPIN]: popinClose,
  [OPEN_POPIN]: popinOpen
};

export default eventsMap;
